import { SvgIcon, type SvgIconProps } from '@components/primitives/SvgIcon';

import ChevronLeft from '../assets/icons/feather/Chevron left.svg?react';

export function ChevronLeftIcon(props: SvgIconProps) {
  return <SvgIcon component={ChevronLeft} inheritViewBox {...props} />;
}
